import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "discipline";

export const getDisciplineList = (filter = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${apiURL}`, {
				...AuthHeader,
				params: {
					filter: JSON.stringify(filter),
				},
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addDisciplineItem = (data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${apiURL}`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateDisciplineItem = (uuid: any, data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${apiURL}`,
				{
					filter: { _id: uuid },
					data: data,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteDisciplineItem = (uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${apiURL}`, {
				params: {
					filter: JSON.stringify({ _id: uuid }),
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
